import React from 'react';
import { useIdentityRole } from '../../hooks/useIdentityRole';
import { IDENTITY_ROLE } from '../../domain/identity';
import PortalApp from '../portal/PortalApp';

// A family's portal login is not a studio (#764), and never gets one here.
//
// Placed in src/App.jsx above every studio provider — settings and its
// studio-zone write, the entitlement provider and its `ensureAccount` call,
// the Paywall, every collection's listener — for SignInGate's reason: a gate
// drawn per route would still have mounted them. A portal-only uid gets the
// Family Portal instead (components/portal/PortalApp.jsx), which sends any
// path that is not one of its own to /portal, so nothing below ever opens for
// it. In the app, /portal itself never reaches this gate: App.jsx's outer
// Routes give it to PortalApp first (#772).
//
// A teacher (no portal claim) and a teacher who is also a parent (`both`) get
// the app exactly as it was: `children` is rendered on the first pass with no
// read in front of it (hooks/useIdentityRole.js says why). A portal claim
// whose billing account has not been read yet waits on the loading screen
// RequireAuth draws.
export default function StudioGate({ children }) {
  const role = useIdentityRole();
  if (role === IDENTITY_ROLE.pending) return <GateLoading />;
  if (role === IDENTITY_ROLE.portal) return <PortalApp />;
  return children;
}

function GateLoading() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--color-gray-50)',
      color: 'var(--color-gray-500)',
      fontSize: '0.875rem',
    }}>
      Loading…
    </div>
  );
}
